import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const formatNumber = ({
  number: numberIn,
  thousandSeparator = '.',
  groupOfDigitsLength = 3,
  decimalSeparator = ',',
  minDecimals = 0,
  maxDecimals = 10,
  abbreviation = 'round'
}) => {
  if (typeof numberIn !== 'number') {
    return numberIn;
  }
  const isNegative = numberIn < 0;
  const number = Math.abs(numberIn);

  let abbreviatedNumber;
  if (abbreviation === 'none') abbreviatedNumber = number;
  else {
    abbreviatedNumber = abbreviation === 'round' ? Math.round(number * (10 ** maxDecimals)) / (10 ** maxDecimals) : Math.trunc(number * (10 ** maxDecimals)) / (10 ** maxDecimals);
  }
  const members = `${abbreviatedNumber}`.split('.');
  const [integerAsString] = members;
  let [, decimalsAsString = ''] = members;
  const len = integerAsString.length;
  const stack = [];
  for (let i = 0; i < len; i += 1) {
    if (i !== 0 && (i % groupOfDigitsLength) === 0) {
      stack.unshift(thousandSeparator);
    }
    stack.unshift(integerAsString.charAt(len - 1 - i));
  }
  if (minDecimals > 0 || decimalsAsString.length > 0) {
    const diff = minDecimals - decimalsAsString.length;
    if (diff > 0) {
      for (let i = 0; i < diff; i += 1) {
        decimalsAsString += '0';
      }
    }
    if (maxDecimals !== undefined) {
      decimalsAsString = decimalsAsString.substring(0, maxDecimals);
    }
    stack.push(decimalSeparator, decimalsAsString);
  }
  if (isNegative) {
    stack.unshift('-');
  }
  return stack.join('');
};

/**
 * Formatea números de acuerdo a las reglas de cada país
 * @number {number} Número a formatear
 * @country {string} Locale del país (this.$i18n.locale)
 * @usePrefix {boolean} Usar o no el prefijo de la moneda
 * @usePrimaryCurrency {boolean} Usar moneda primaria. Sólo para country='cl', si es true, usa UF, sino, usa CLP.
 */
export const formatNumberByCountry = ({
  number,
  countryIn,
  usePrefix = true,
  fractionDigits = 2,
  currencyType = 'secondary'
}) => {
  const formatLocales = {
    br: {
      primary: {},
      secondary: {
        prefix: 'R$ ',
        thousandSeparator: ',',
        decimalSeparator: '.',
        minDecimals: fractionDigits,
        maxDecimals: fractionDigits
      }
    },
    cl: {
      primary: {
        prefix: 'UF ',
        thousandSeparator: '.',
        decimalSeparator: ',',
        minDecimals: fractionDigits,
        maxDecimals: fractionDigits
      },
      secondary: {
        prefix: '$ ',
        thousandSeparator: '.',
        decimalSeparator: ',',
        minDecimals: fractionDigits,
        maxDecimals: fractionDigits
      }
    },
    pe: {
      primary: {},
      secondary: {
        prefix: 'S/ ',
        thousandSeparator: ',',
        decimalSeparator: '.',
        minDecimals: fractionDigits,
        maxDecimals: fractionDigits
      }
    }
  };
  const { prefix, thousandSeparator, decimalSeparator, minDecimals, maxDecimals } = formatLocales[countryIn][currencyType];
  const isNegative = number < 0;
  const formattedNumber = formatNumber({ number: Math.abs(number), thousandSeparator, groupOfDigitsLngth: 3, decimalSeparator, minDecimals, maxDecimals });
  return `${isNegative ? '-' : ''}${prefix && usePrefix ? `${prefix}` : ''}${formattedNumber}`;
};
export function formatDate(dateString, format = 'DD/MM/YYYY') {
  const invalid = 'Invalid Date';
  if (dateString === null || dateString === undefined) return invalid;
  const date = dayjs.utc(dateString);
  return date.isValid() ? date.format(format) : invalid;
}

export function stringToDate(dateString) {
  const date = dayjs(dateString);
  return dateString && date.isValid() ? date.toDate() : null;
}

export function formatPercentage(number, maxDecimals = 2, decimalSeparator = '.') {
  return formatNumber({
    number: number * 100,
    maxDecimals,
    decimalSeparator
  });
}

export function formatName(name) {
  if (!name || typeof name !== 'string') {
    return '';
  }
  return name.toLowerCase().replace(/\b\w/g, char => {
    return char.toUpperCase();
  });
}
